import styled from 'styled-components'

export const Value = styled.span(({ theme, isReadOnly }) => ({
  fontStyle: isReadOnly ? 'italic' : 'normal',
  color: isReadOnly ? theme.colors.n06 : 'inherit'
}))
